<template>
  <div v-if="items.length > 0" class="fixed top-4 right-4 z-50 w-96 space-y-2">
    <div
      v-for="item in items"
      :key="item.id"
      class="bg-white rounded-2xl border border-neutral-100 shadow-lg p-4 animate-slide-in cursor-pointer hover:border-neutral-200 transition-colors"
      @click="onClick(item)"
    >
      <div class="flex items-start gap-3">
        <!-- Иконка-колокольчик в кружке -->
        <div class="w-10 h-10 rounded-xl bg-neutral-100 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </div>

        <!-- Заголовок + тело -->
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-neutral-900 truncate">{{ item.title }}</p>
          <p v-if="item.message" class="text-sm text-neutral-500 mt-0.5 whitespace-pre-line">{{ item.message }}</p>
        </div>

        <!-- Крестик -->
        <button
          @click.stop="remove(item.id)"
          class="text-neutral-400 hover:text-neutral-600 focus:outline-none flex-shrink-0"
        >
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useNotificationsStore } from '@/stores/notifications';

export default {
  name: 'NotificationToast',
  data() {
    return {
      items: [],
      nextId: 1,
    };
  },
  methods: {
    /**
     * Показать тост уведомления
     * @param {{id: number, title: string, message: string, url: string|null}} notification
     */
    show(notification) {
      const id = this.nextId++;
      this.items.push({
        id,
        notificationId: notification.id,
        title: notification.title,
        message: notification.message,
        url: notification.url || null,
      });

      // Авто-скрытие через 5 секунд
      setTimeout(() => {
        this.remove(id);
      }, 5000);
    },

    async onClick(item) {
      // Клик по тосту = уведомление прочитано
      if (item.notificationId) {
        try {
          await axios.post('/api/notifications/' + item.notificationId + '/mark-as-read');
          useNotificationsStore().decrementCount();
        } catch (e) {
          console.error('Ошибка отметки уведомления:', e);
        }
      }
      if (item.url) {
        this.$router.push(item.url);
      }
      this.remove(item.id);
    },

    remove(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index > -1) {
        this.items.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
@keyframes slide-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-slide-in {
  animation: slide-in 0.3s ease-out;
}
</style>
